import http from '@/js/Http'
import {AxiosOptions} from 'guaxinim-web'

export default {
  create(entity) {
    const url = `/classificacaoIndicador/`
    return new Promise((resolve, reject) => {
      http.post(url, entity).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  edit(id, entity) {
    const url = `/classificacaoIndicador/${id}`
    return new Promise((resolve, reject) => {
      http.put(url, entity).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findClassificacaoIndicadorFinderDTO(busca, tipo, folha, limite) {
    const params = {
      busca,
      tipo,
      folha,
      limite
    }
    const options = {
      ...AxiosOptions,
      params
    }
    const url = `/classificacaoIndicador/finder`
    return new Promise((resolve, reject) => {
      http.get(url, options).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findDTOByID(id) {
    const url = `/classificacaoIndicador/dto/${id}`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findDTOs(ids, filterparams) {
    const params = {
      ids,
      filterparams
    }
    const options = {
      ...AxiosOptions,
      params
    }
    const url = `/classificacaoIndicador/dto`
    return new Promise((resolve, reject) => {
      http.get(url, options).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findEntities(ids) {
    const params = {
      ids
    }
    const options = {
      ...AxiosOptions,
      params
    }
    const url = `/classificacaoIndicador/`
    return new Promise((resolve, reject) => {
      http.get(url, options).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  findEntityByID(id) {
    const url = `/classificacaoIndicador/${id}`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  getDtoPresentation() {
    const url = `/classificacaoIndicador/dto/presentation`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  getPresentation() {
    const url = `/classificacaoIndicador/presentation`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  newEntity() {
    const url = `/classificacaoIndicador/new`
    return new Promise((resolve, reject) => {
      http.get(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  },
  remove(id) {
    const url = `/classificacaoIndicador/${id}`
    return new Promise((resolve, reject) => {
      http.delete(url).then(response => {
        resolve(response.data)
      }).catch(err => reject((!err.response || !err.response.data) ? err : err.response.data))
    })
  }
}